<template>
  <v-menu
    ref="main_search_menu"
    value="showSearchResults"
    bottom
    origin="center center"
    transition="scale-transition"
    offset-y
    nudge-bottom="2"
    z-index="500"
    max-height="calc(90vh - 64px)"
    persistent
    close-on-content-click
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        ref="main_search_field"
        id="main_search_field"
        autocomplete="off"
        flat
        solo
        light
        clearable
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-xs-only"
        v-model="searchTerm"
        z-index="600"
        @focus="searchFocus = true"
        v-on="on"
      />
    </template>
    <v-card @keydown.esc="showSearchResults = false">
      <v-list v-if="customersList.length > 0">
        <v-list-item
          v-for="customer in customersList"
          :key="customer.id"
          @click="clickCustomer(customer.id)"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-list-item-title v-on="on">
                {{ customer.name }}
              </v-list-item-title>
            </template>
            <span
              v-if="customer && customer.phone && customer.phone.length > 0"
            >
              <div v-for="phone in customer.phone" :key="phone.id">
                {{
                  [
                    phone.label[0].toUpperCase() + phone.label.slice(1),
                    phone.number
                  ].join(": ")
                }}
              </div>
            </span>
            <span v-else>No phone number listed</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
      <v-main v-if="!searchTerm && searchFocus" class="py-4 px-4">
        Search customers by name or phone number
      </v-main>
      <v-main
        v-if="searchTerm && searchFocus"
        class="py-4 px-4"
        @click="onAddCustomer"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on" class="full-width" @click="onAddCustomer">
              <v-icon left>mdi-account-plus</v-icon> Add New Customer
            </v-btn>
          </template>
          <span>New Customer</span>
        </v-tooltip>
      </v-main>
    </v-card>
  </v-menu>
</template>

<script>
import Fuse from "fuse.js";
import { CUSTOMER_SEARCH_FUSE_OPTIONS } from "../../globalVars";

export default {
  name: "MainSearch",
  components: {},
  data() {
    return {
      isFalse: false,
      showSearchResults: false,
      searchTerm: "",
      searchFocus: false
    };
  },
  async created() {},
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    customerLookup() {
      return this.$store.getters["entities/customerLookups/query"]()
        .orderBy("date", "desc")
        .get();
    },
    customersList() {
      if (this.searchTerm == "") {
        return this.customerLookup.slice(0, 0);
      } else {
        let options = Object.assign({}, CUSTOMER_SEARCH_FUSE_OPTIONS);
        let fuse = new Fuse(this.customerLookup, options);
        let result = fuse.search(this.searchTerm);
        return result.slice(0, 100);
      }
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    }
  },
  methods: {
    async clickCustomer(id) {
      if (this.$parent.$parent.$options.name == "TopNavigation") {
        await this.$store.dispatch("entities/customers/clickCustomer", {
          customerId: id
        });
        this.$router.push({ path: "/customers/" });
        //this.scrollToBottomOfHistory();
      } else if (this.$parent.$options.name == "CustomerRightRail") {
        if (this.$route.name == "calls") {
          await this.$parent.editContactInfo({
            customerId: id,
            type: "phone",
            details: this.$parent.$parent.$parent.$parent.selectedCallNumber.slice(
              2
            )
          });
        } else if (this.$route.name == "chats") {
          const chatId = this.$parent.$parent.$parent.$parent.selectedChatId;
          await this.$store.dispatch("entities/chats/updateChat", {
            where: chatId,
            data: {
              id: chatId,
              isDirty: true,
              customerId: id
            }
          });
          let currentChat = this.$root.$children[0].$refs["router-view"].$refs[
            "history-center-rail"
          ].currentSelectedChat;
          currentChat.customerId = id;
          await this.$root.$children[0].$refs["router-view"].$refs[
            "chats-left-rail"
          ].clickChat(currentChat);
          await this.$store.dispatch("entities/chatLookups/hydrate");
        }
      }
    },
    onAddCustomer() {
      let vueThis = this;
      this.$root.$children[0].showCustomerEditorModals = true;
      let timer = setTimeout(function checkCustomerEditorModals() {
        vueThis.$root.$children[0].showCustomerEditorModals = true;
        if (
          vueThis.$root.$children[0].$refs["customer-editor-modals"] !=
          undefined
        ) {
          let theContainer =
            vueThis.$root.$children[0].$refs["customer-editor-modals"];
          theContainer.CustomerId = -1;
          theContainer.showCustomerDetailFormModal = true;
          timer = null;
        } else {
          setTimeout(vueThis.onAddCustomer, 100);
        }
      }, 100);
    }
  },
  watch: {
    searchTerm: function(newVal, oldVal) {
      if (oldVal && newVal && newVal.length > 1) {
        this.$refs["main_search_menu"].isActive = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
